export default "__VITE_PUBLIC_ASSET__bab0f7d4__"